import {
    ChangeDetectionStrategy,
    Component,
} from "@angular/core";
import { ScrollToTopDirective } from "@Front-end/ui/directives/scroll-to-top";
import {
    ButtonV3KindDirective,
    ButtonV3PaletteDirective,
    ButtonV3SizeDirective,
} from "@Front-end/ui/modules/button-v3";
import { IconComponent } from "@Front-end/ui/modules/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "ls-scroll-to-top",
    templateUrl: "./scroll-to-top.component.html",
    styleUrls: ["./scroll-to-top.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslateModule,
        ButtonV3KindDirective,
        ButtonV3PaletteDirective,
        ButtonV3SizeDirective,
        ScrollToTopDirective,
        IconComponent,
    ],
})
export class ScrollToTopComponent {
}
